declare const rm: {
  AutoComplete?: {
    dataSources?: {
      users?: string
      issues?: string
    }
  }
} | undefined

export function rmDataSources() {
  if (typeof rm === 'undefined')
    return null
  return rm?.AutoComplete?.dataSources ?? null
}
